import { Image, Text } from '@chakra-ui/react';
import type { Options } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';

import type { ArticleUiType } from './types';

export const getRenderOptions = (article: ArticleUiType): Options => {
  return {
    renderNode: {
      [BLOCKS.HEADING_1]: (node, children) => (
        <Text as="h2" mt={{ base: 4, desktop: 6 }} textStyle="h4Bold">
          {children}
        </Text>
      ),
      [BLOCKS.LIST_ITEM]: (node, children) => (
        <Text ml={4} as="li" textStyle="body">
          {children}
        </Text>
      ),
      [BLOCKS.EMBEDDED_ASSET]: (node, _children) => {
        // Find the asset data by matching the node's sys.id with the fetched assets
        const assetId = node.data.target.sys.id;
        const asset = article.content.links.assets.block.find(
          (a) => a.sys.id === assetId,
        );

        if (asset) {
          switch (asset.contentType) {
            case 'image/jpeg':
            case 'image/png':
              return (
                <Image
                  src={`${asset.url}?w=500`}
                  alt={asset.title || 'Embedded Image'}
                  title={asset.description}
                  width="100%"
                  height="auto"
                />
              );
            // Add cases for other content types if necessary
            default:
              return <p>Unsupported format</p>;
          }
        }

        return <p>Asset not found</p>;
      },
    },
  };
};
